import script from "./ImpactStatement.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImpactStatement.vue?vue&type=script&setup=true&lang=ts"

import "./ImpactStatement.vue?vue&type=style&index=0&id=f012cc74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f012cc74"]])

export default __exports__